import Vue from 'vue'
import Router from 'vue-router'
import home from '../pages/home/home'
import classdetails from '../pages/classdetails/classdetails.vue'
import newclassdetails from '../pages/newclassdetails/newclassdetails.vue'
import personage from '../pages/personage/personage.vue'
import course from '../pages/course/course.vue'
import live from '../pages/live/live.vue' //课程菜单主页
import courseDetails from '../pages/courseDetails/courseDetails.vue' //课程详情
import money from '../pages/money/money.vue' //我的钱包
import courseOrder from '../pages/courseOrder/courseOrder.vue' //课程订阅
import zhiboxq from '../pages/zhiboxq/zhiboxq.vue' //直播详情
import userData from '../pages/userData/userData.vue' //个人资料
import binding from '../pages/binding/binding.vue' //账号绑定
import resource from '../pages/resource/resource.vue' //资料中心
import set from '../pages/set/set.vue' //设置
import details from '../pages/Details/details.vue' //详情
import team from '../pages/team/team.vue' //我的团队
import generalize from '../pages/generalize/generalize.vue' //推广
import earnings from '../pages/earnings/earnings.vue' //我的收益
import theorder from '../pages/TheOrder/theorder.vue' //我的收益————订单
import withdrawal from '../pages/withdrawal/withdrawal.vue' // 我的收益————提现
import studies from '../pages/studies/studies.vue'
import altername from '../pages/alterinfo/altername.vue'
import qianming from '../pages/alterinfo/qianming.vue'
import apply from '../pages/apply/apply.vue' // 应用
import management from '../pages/management/management.vue' // 应用管理


import login from '../components/Login'
import bangdingjiazhang from '../components/bangdingjiazhang.vue' // 绑定家长
import bangdingsj from '../components/bangdingsh.vue' // 绑定手机
import register from '../components/register'
import userinfo from '../components/userInfo'
import playback from '../pages/playback/playback.vue'
import whiteBoard from '../pages/whiteBoard/whiteBoard.vue'
Vue.use(Router)
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    // mode: "history",
    routes: [{
            path: '/',
            name: 'home',
            component: home
        },
        {
            path: '/classdetails',
            name: 'classdetails',
            component: classdetails,
        },
        {
            path: '/newclassdetails',
            name: 'newclassdetails',
            component: newclassdetails,
        },
        {
            path: '/login',
            name: 'login',
            component: login,
        },
        {
            path: '/register',
            name: 'register',
            component: register,
        },
        {
            path: '/userinfo',
            name: 'userinfo',
            component: userinfo,
        },
        {
            path: '/personage',
            name: 'personage',
            component: personage,
        },
        {
            path: '/course',
            name: 'course',
            component: course,
        },
        {
            path: '/management',
            name: 'management',
            component: management,
        },
        
        {
            path: '/live',
            name: 'live',
            component: live,
        },
        {

            path: '/playback',
            name: 'playback',
            component: playback,
        },
        {
            path: '/whiteBoard',
            name: 'whiteBoard',
            component: whiteBoard,
        },
        {
            path: '/CourseDetails',
            name: 'courseDetails',
            component: courseDetails,
        },
        {
            path: '/Money',
            name: 'money',
            component: money,
        },
        {
            path: '/CourseOrder',
            name: 'courseOrder',
            component: courseOrder,
        },
        {
            path: '/UserData',
            name: 'userData',
            component: userData,
        },
        {
            path: '/Binding',
            name: 'binding',
            component: binding,
        },
        {
            path: '/Resource',
            name: 'resource',
            component: resource,
        },
        {
            path: '/Set',
            name: 'set',
            component: set,
        },
        {
            path: '/Details',
            name: 'details',
            component: details,
        },
        {
            path: '/altername',
            name: 'altername',
            component: altername,
        },
        {
            path: '/qianming',
            name: 'qianming',
            component: qianming,
        },
        {
            path: '/team',
            name: 'team',
            component: team,
        },
        {
            path: '/generalize',
            name: 'generalize',
            component: generalize
        },
        {
            path: '/earnings',
            name: 'earnings',
            component: earnings
        },
        {
            path: '/theorder',
            name: 'theorder',
            component: theorder
        },
        {
            path: '/withdrawal',
            name: 'withdrawal',
            component: withdrawal
        },
        {
            path: '/zhiboxq',
            name: 'zhiboxq',
            component: zhiboxq
        },
        {
            path: '/bangdingsj',
            name: 'bangdingsj',
            component: bangdingsj
        },
        {
            path: '/studies',
            name: 'studies',
            component: studies
        },
        {
            path: '/apply',
            name: 'apply',
            component: apply
        }, {
            path: '/bangdingjiazhang',
            name: 'bangdingjiazhang',
            component: bangdingjiazhang
        },

    ],

})


// WEBPACK FOOTER //
// ./src/router/index.js